import * as React from "react";
import { forwardRef } from "react";
const SvgSendReceive = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 20, viewBox: "0 0 14 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 12.99L9 20L11 20L11 12.99L14 12.99L10 9L6 12.99L9 12.99ZM8 7.01L5 7.01L5 3.93402e-07L3 4.80825e-07L3 7.01L3.06417e-07 7.01L4 11L8 7.01Z", fill: "#323232" }));
const ForwardRef = forwardRef(SvgSendReceive);
export { ForwardRef as ReactComponent };
